import { Checkbox, Stack, TextInput } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { IconFolder } from '@tabler/icons-react'
import { useIntl } from 'react-intl'
import { SUPPORTED_VIDEO_FORMATS } from '@/components/vlm/vlmPipelineConfig'
import { PipelineFormValues } from './VlmPipelineForm'

type FolderSourceSettingsProps = {
  form: UseFormReturnType<PipelineFormValues>
}

export const FolderSourceSettings = ({ form }: FolderSourceSettingsProps) => {
  const intl = useIntl()

  return (
    <Stack gap="md">
      <TextInput
        label={intl.formatMessage({
          id: 'vlm.pipelines.create.folder.label'
        })}
        description={intl.formatMessage(
          { id: 'vlm.pipelines.create.folder.description' },
          { formats: SUPPORTED_VIDEO_FORMATS.join(', ') }
        )}
        placeholder={intl.formatMessage({
          id: 'vlm.pipelines.create.folder.placeholder'
        })}
        leftSection={<IconFolder size={16} />}
        {...form.getInputProps('source.watchPath')}
      />

      <Checkbox
        label={intl.formatMessage({
          id: 'vlm.pipelines.create.folder.deleteOriginal'
        })}
        {...form.getInputProps('source.deleteOriginal', { type: 'checkbox' })}
      />
    </Stack>
  )
}
